module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tjsq-box"
  }, [_c('div', {
    staticClass: "tjsq-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tjsq-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqingyitijiao')))]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.shenqingtijiaodesc')))]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-info"
  }, [_c('div', {
    staticClass: "tjsq-info-item"
  }, [_c('span', {
    staticClass: "tjsq-info-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhiboriqi')))]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-info-item-right"
  }, [_c('span', {
    staticClass: "tjsq-info-item-value"
  }, [_vm._v(_vm._s(_vm.liveDate))]), _vm._v(" "), _c('img', {
    staticClass: "tjsq-info-item-arrow",
    attrs: {
      "src": require("../../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-info-item"
  }, [_c('span', {
    staticClass: "tjsq-info-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shijianshiduan')))]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-info-item-right"
  }, [_c('span', {
    staticClass: "tjsq-info-item-value"
  }, [_vm._v(_vm._s(_vm.timeSlot))]), _vm._v(" "), _c('img', {
    staticClass: "tjsq-info-item-arrow",
    attrs: {
      "src": require("../../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-status"
  }, [_c('span', {
    staticClass: "tjsq-status-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zhuangtai')))]), _vm._v(" "), _c('span', {
    staticClass: "tjsq-status-value"
  }, [_vm._v(_vm._s(_vm.$t('all.daishenhe')))])]), _vm._v(" "), _c('div', {
    staticClass: "tjsq-btn",
    on: {
      "click": _vm.handleViewRecord
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chakanshenheJilu')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tjsq-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/image/tijiaoshengqing_134@2x.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-016659b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/tijiaoshenqing/tijiaoshenqing.vue
// module id = 943
// module chunks = 1